import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="local-time"
export default class extends Controller {
  static values = {
    time: String
  }

  connect() {
    const isoTime = this.timeValue
    const date = new Date(isoTime)
    
    if (isNaN(date.getTime())) {
      console.warn("Invalid date:", isoTime)
      return
    }

    // Format the time in the user's local timezone
    const formattedTime = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    })

    this.element.textContent = formattedTime
  }
}

